<template>
  <v-app>
    <navigation-drawer></navigation-drawer>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import NavigationDrawer from './NavigationDrawer.vue'
export default {
    components:{
        NavigationDrawer,
    }
}
</script>